export const tourGuideSteps = [
  {
    selector: "#message-batch-details-header",
    content:
      "This area shows the summary of the message batch details.",
  },
  {
    selector: "#message-batch-details-filter",
    content:
      "Users can filter the messages within the message batch based on the reprocessing status.",
  },
  {
    selector: "#message-batch-details-data-grid",
    content:
      "This data grid contains the list of messages that were reprocessed based on the filter parameters above.",
  },
  {
    selector: "#Batch-Details-column-0",
    content:
      "List of the new Message Ids after reprocessing.  Press the link below to navigate to the View Message page.",
  },
  {
    selector: "#Batch-Details-column-1",
    content:
      "List of the original Message Ids that were used for reprocessing.  Press the link below to navigate to the View Message page.",
  },
];
